import { render, staticRenderFns } from "./TrackingProjects.vue?vue&type=template&id=567fa124&scoped=true&"
import script from "./TrackingProjects.vue?vue&type=script&lang=ts&"
export * from "./TrackingProjects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567fa124",
  null
  
)

export default component.exports